import { useEffect, useState, JSX } from "react";
import NextImage from "@/app/components/lib/NextImage";
import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import PlayVideoIcon from "@/app/components/common-builder/gallery/PlayVideoIcon";
import { IProductImage } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
interface Props {
  children: JSX.Element[];
  thumbnails: IProductImage[];
  id: number;
  size?: number;
  isSamll?: boolean;
  sliderWidth: number;
  ratio: number;
}
const ThumbMailSlider: React.FC<Props> = ({
  children,
  thumbnails,
  id,
  size = 137,
  isSamll = false,
  sliderWidth,
  ratio,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    setCurrentSlide(-1);
  }, [id]);
  return (
    <>
      <div
        style={{ position: "relative", display: "flex", gap: isSamll ? 8 : 16 }}
      >
        {thumbnails?.length > 1 && (
          <div
            className="slider-thumbmail dots"
            style={{ marginTop: 0, maxWidth: sliderWidth }}
          >
            <EmblaSlider selectedIndex={currentSlide} direction="vertical">
              <EmblaSlider.EmblaSliderViewport className="h-100">
                <EmblaSlider.EmblaSliderContainer
                  height={sliderWidth * ratio}
                  direction="vertical"
                  gap={16}
                  slides={[
                    ...thumbnails?.map((img, i) => ({
                      component: (
                        <div
                          key={i}
                          className={`thumbmail dot ${
                            currentSlide === i ? "with-border" : ""
                          }`}
                          style={{
                            width: size,
                            height: size,
                            borderRadius: isSamll ? 8 : 16,
                            position: "relative",
                          }}
                          onClick={() => setCurrentSlide(i === 0 ? -1 : i)}
                        >
                          <NextImage
                            alt="product"
                            src={img.thumbnail_url}
                            width={size}
                            height={size}
                            objectFit="contain"
                          />
                          {img?.type === "video" && (
                            <PlayVideoIcon
                              style={{
                                position: "absolute",
                                top: "20%",
                                left: "20%",
                                zIndex: 5,
                                cursor: "pointer",
                                transform: "scale(0.5)",
                              }}
                            />
                          )}
                        </div>
                      ),
                      width: "auto" as TSlideWidith,
                    })),
                  ]}
                />
              </EmblaSlider.EmblaSliderViewport>
            </EmblaSlider>
          </div>
        )}
        <EmblaSlider
          selectedIndex={currentSlide}
          setSelectedIndex={setCurrentSlide}
        >
          <EmblaSlider.EmblaSliderViewport>
            <EmblaSlider.EmblaSliderContainer
              gap={0}
              slides={[
                ...(children as Array<JSX.Element>)?.map((child, key) => ({
                  component: (
                    <div key={key} className="next-image-dynamic-height">
                      {child}
                    </div>
                  ),
                  width: "100%" as TSlideWidith,
                })),
              ]}
            />
            <EmblaSlider.EmblaSliderPrevNextButtons />
          </EmblaSlider.EmblaSliderViewport>
        </EmblaSlider>
        {children.length > 1 && thumbnails?.length === 0 && (
          <div
            className="dots"
            style={{
              position: "absolute",
              bottom: 16,
              width: "100%",
            }}
          >
            {[
              ...children?.map((_, i) => (
                <button
                  key={i}
                  className={`dot ${currentSlide === i ? "active" : ""}`}
                  onClick={() => setCurrentSlide(i === 0 ? -1 : i)}
                />
              )),
            ]}
          </div>
        )}
      </div>
    </>
  );
};

export default ThumbMailSlider;
